// js
export const LOGOUT = 'USER/LOGOUT';
export const UPDATE_USER = 'USER/UPDATE_USER';
